import React, { useState } from "react";
import {
  Modal,
  Table,
  Button,
  Form,
  Input,
  Space,
  Divider,
  Tag,
  Timeline,
} from "antd";
import {
  PlusOutlined,
  WarningOutlined,
  ClockCircleOutlined,
} from "@ant-design/icons";
import moment from "moment";
import {
  useGetEquipmentIssues,
  useAddIssue,
} from "../../../hooks/useEquipment";

const { TextArea } = Input;

const IssuesModal = ({ visible, onCancel, equipment }) => {
  const [showReportForm, setShowReportForm] = useState(false);
  const [form] = Form.useForm();

  const { data: issues = [], isLoading } = useGetEquipmentIssues(equipment?.id);
  const addIssueMutation = useAddIssue();

  const handleReportIssue = async (values) => {
    addIssueMutation.mutate(
      {
        equipmentId: equipment.id,
        issueDetails: values.issueDetails,
      },
      {
        onSuccess: () => {
          form.resetFields();
          setShowReportForm(false);
        },
      },
    );
  };

  const columns = [
    {
      title: "Reported Date",
      dataIndex: "issueTimestamp",
      key: "issueTimestamp",
      width: 180,
      render: (date) => (
        <Space>
          <ClockCircleOutlined />
          {moment(date).format("DD/MM/YYYY HH:mm")}
        </Space>
      ),
    },
    {
      title: "Issue Details",
      dataIndex: "issueDetails",
      key: "issueDetails",
      render: (text) => <div className="whitespace-pre-wrap">{text}</div>,
    },
  ];

  return (
    <Modal
      title={
        <div className="flex items-center justify-between">
          <Space>
            <WarningOutlined className="text-orange-500" />
            <span>Issues - {equipment?.name}</span>
            {issues.length > 0 && (
              <Tag color="orange">
                {issues.length} Issue{issues.length !== 1 ? "s" : ""}
              </Tag>
            )}
          </Space>
        </div>
      }
      open={visible}
      onCancel={onCancel}
      width={800}
      footer={null}
    >
      {equipment && (
        <>
          <div className="mb-4 p-4 flex-row flex justify-between bg-gray-50 rounded-lg">
            <Space size="large">
              <div>
                <strong>Code:</strong> {equipment.code}
              </div>
              <div>
                <strong>Name:</strong> {equipment.name}
              </div>
            </Space>
            <Button
              type="primary"
              danger
              icon={<PlusOutlined />}
              onClick={() => setShowReportForm(!showReportForm)}
            >
              Report Issue
            </Button>
          </div>

          {showReportForm && (
            <>
              <Divider>Report New Issue</Divider>
              <Form form={form} layout="vertical" onFinish={handleReportIssue}>
                <Form.Item
                  name="issueDetails"
                  label="Issue Details"
                  rules={[
                    { required: true, message: "Please describe the issue" },
                    {
                      min: 10,
                      message: "Please provide at least 10 characters",
                    },
                  ]}
                >
                  <TextArea
                    rows={4}
                    placeholder="Describe the issue in detail..."
                    showCount
                    maxLength={500}
                  />
                </Form.Item>

                <Form.Item>
                  <Space>
                    <Button
                      type="primary"
                      danger
                      htmlType="submit"
                      loading={addIssueMutation.isLoading}
                    >
                      Report Issue
                    </Button>
                    <Button onClick={() => setShowReportForm(false)}>
                      Cancel
                    </Button>
                  </Space>
                </Form.Item>
              </Form>
              <Divider />
            </>
          )}

          <h3 className="text-lg font-semibold mb-3">Issue History</h3>

          {issues.length === 0 ? (
            <div className="text-center py-8 text-gray-400">
              <p className="mt-2">No issues reported for this equipment</p>
            </div>
          ) : (
            <>
              {/* Timeline View */}
              {/* <div className="mb-4">
                                <Timeline
                                    mode="left"
                                    items={issues.map(issue => ({
                                        color: 'red',
                                        label: moment(issue.issueTimestamp).format('DD/MM/YYYY HH:mm'),
                                        children: (
                                            <div className="bg-orange-50 p-3 rounded-lg">
                                                <div className="whitespace-pre-wrap text-gray-700">
                                                    {issue.issueDetails}
                                                </div>
                                            </div>
                                        )
                                    }))}
                                />
                            </div> */}

              {/* <Divider /> */}

              {/* Table View */}
              <Table
                columns={columns}
                dataSource={issues}
                loading={isLoading}
                rowKey="id"
                pagination={{ pageSize: 5 }}
                size="small"
              />
            </>
          )}
        </>
      )}
    </Modal>
  );
};

export default IssuesModal;
